// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Selectors
import selectedJobAndGrid$ from 'hfty-soil-jobs/src/selectors/selectedJobAndGrid'
import userSelectorOptions$ from './userSelectorOptions'

export default createSelector(
  [
    selectedJobAndGrid$,
    userSelectorOptions$,
  ],
  (selectedJob, heftyUsers) => {
    if (selectedJob) {
      const createdBy = _find(heftyUsers, (user) => {
        return user.value === selectedJob.created_by
      })
      const assignedTo = _find(heftyUsers, (user) => {
        return user.value === selectedJob.assigned_to
      })
      return {
        ...selectedJob,
        created_by: createdBy ? createdBy.label : '',
        assigned_to: assignedTo ? assignedTo.label : '',
      }
    }
    return null
  }
)
